/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {SwitchAccountModel} from "../../models/switch-account-model";


export interface SwitchAccountPutParams {
    body?: SwitchAccountModel,
    userGuid: string;
}

export function switchAccountPut(http: HttpClient, rootUrl: string, params: SwitchAccountPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(rootUrl, switchAccountPut.PATH, 'put');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.body(params.body, 'application/json');

    if (params.userGuid) {
        rb.path('userGuid', params.userGuid, { 'style': 'simple' });
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<void>;
        })
    );
}

switchAccountPut.PATH = '/api/v1/users/{userGuid}/switch-account'
